import { render, staticRenderFns } from "./recommendCommon.vue?vue&type=template&id=0d203a1e&scoped=true&"
import script from "./recommendCommon.vue?vue&type=script&lang=js&"
export * from "./recommendCommon.vue?vue&type=script&lang=js&"
import style0 from "./recommendCommon.vue?vue&type=style&index=0&id=0d203a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d203a1e",
  null
  
)

export default component.exports